import { ref, computed } from 'vue'

export function useCoursePagination() {
  const currentPage = ref(1)
  const lastPage = ref(-1)
  const showPagination = ref(false)
  const loading = ref(false)

  const hasNextPage = computed(() => 
    lastPage.value === -1 || currentPage.value < lastPage.value
  )

  const hasPrevPage = computed(() => currentPage.value > 1)
  
  const showFirstPage = computed(() => currentPage.value - 2 > 0)
  
  const showLastPage = computed(() => 
    lastPage.value !== -1 && lastPage.value >= currentPage.value + 2
  )

  const goToPage = (page) => {
    currentPage.value = page
  }

  const nextPage = () => {
    if (hasNextPage.value) {
      currentPage.value++
    }
  }

  const prevPage = () => {
    if (hasPrevPage.value) {
      currentPage.value--
    }
  }

  const resetPagination = () => {
    currentPage.value = 1
    lastPage.value = -1
    showPagination.value = false
  }

  const updatePagination = (data, pageSize = 10) => {
    if (data.length > 0) {
      showPagination.value = true
      if (data.length < pageSize) {
        lastPage.value = currentPage.value
      }
    }
  }

  return {
    currentPage,
    lastPage,
    showPagination,
    loading,
    hasNextPage,
    hasPrevPage,
    showFirstPage,
    showLastPage,
    goToPage,
    nextPage,
    prevPage,
    resetPagination,
    updatePagination
  }
}